import TextField from '@mui/material/TextField'
import { forwardRef } from 'react'
import { TextFieldProps } from '@mui/material/TextField'
import { usePortalTheme } from '@/ui/components/portal-preview/use-portal-theme'

const ReverTextField = forwardRef<HTMLInputElement, TextFieldProps>(
  (props, ref) => {
    const theme = usePortalTheme()

    const color =
      theme.colors?.primary?.main === 'transparent'
        ? '#000'
        : theme.colors?.primary?.main

    const variant = theme?.inputVariant?.toLowerCase()

    return (
      <TextField
        variant={variant === 'standard' ? 'standard' : 'outlined'}
        inputRef={ref}
        sx={{
          '& label.Mui-focused': {
            color: color
          },
          '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
              borderColor: color
            }
          },
          '& .MuiInput-underline:before': {
            borderBottomColor: color
          },
          '& .MuiInput-underline:after': {
            borderBottomColor: color
          }
        }}
        InputLabelProps={{
          sx: {
            fontFamily: 'Roobert'
          }
        }}
        InputProps={{
          sx: {
            fontFamily: 'Roobert'
          }
        }}
        FormHelperTextProps={{
          sx: {
            fontFamily: 'Roobert',
            fontWeight: 500
          }
        }}
        {...props}
      />
    )
  }
)
ReverTextField.displayName = 'ReverTextField'

export default ReverTextField
